import { render, staticRenderFns } from "./medicion-mortalidad-grafica.vue?vue&type=template&id=1b4c76ca&scoped=true&"
import script from "./medicion-mortalidad-grafica.vue?vue&type=script&lang=js&"
export * from "./medicion-mortalidad-grafica.vue?vue&type=script&lang=js&"
import style0 from "./medicion-mortalidad-grafica.vue?vue&type=style&index=0&id=1b4c76ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c76ca",
  null
  
)

export default component.exports